import { render, staticRenderFns } from "./EditRolePage.vue?vue&type=template&id=8d930582&scoped=true&"
import script from "./EditRolePage.vue?vue&type=script&lang=js&"
export * from "./EditRolePage.vue?vue&type=script&lang=js&"
import style0 from "./EditRolePage.vue?vue&type=style&index=0&id=8d930582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d930582",
  null
  
)

export default component.exports